// extracted by mini-css-extract-plugin
export default {"about":"AddAbout_about__ia88g","card":"AddAbout_card__wkhQ6","progress":"AddAbout_progress__ykf1O","progress-bar":"AddAbout_progress-bar__SknuR","group":"AddAbout_group__zfM8a"};